module.exports = __webpack_public_path__ + "static/media/chaliceExplore.c67a8ac9.png";